import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import GroupHome     from './GroupHome';
import GroupMembers  from './GroupMembers';
import GroupEvents   from './GroupEvents';
import GroupFinances from './GroupFinances';
import GroupTodos    from './GroupTodos';

function NavItem({ icon, label, to, navigate, location, onClick }) {
  const active = location.pathname === to;
  return (
    <button className={`nav-item${active ? ' active' : ''}`}
      onClick={() => { navigate(to); onClick && onClick(); }}>
      <span style={{ fontSize: 15 }}>{icon}</span> {label}
    </button>
  );
}

export default function GroupLayout() {
  const { profile, member, signOut } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();
  const [sideOpen, setSideOpen] = useState(false);

  useEffect(() => { setSideOpen(false); }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = sideOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [sideOpen]);

  const name = member ? `${member.first_name} ${member.last_name}` : profile?.email || 'Leader';
  function logout() { signOut(); navigate('/login'); }
  function closeMenu() { setSideOpen(false); }

  return (
    <div className="app-layout">

      {sideOpen && (
        <div onClick={closeMenu}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 199 }} />
      )}

      <div className={`sidebar blue${sideOpen ? ' open' : ''}`}>
        <div className="sidebar-logo">
          <div className="s-logo-inner">
             <img src="/pcea-logo.png" alt="PCEA" style={{ width:28, height:28, objectFit:'contain' }} className="mobile-hide" />
            <div><div className="s-title">Group Portal</div><div className="s-sub">PCEA Thingati</div></div>
          </div>
        </div>
        <div style={{ flex: 1, paddingBottom: 8 }}>
          <div className="nav-section">My Group</div>
          <NavItem icon="📊" label="Dashboard"  to="/group"           navigate={navigate} location={location} onClick={closeMenu} />
          <NavItem icon="👥" label="Members"    to="/group/members"   navigate={navigate} location={location} onClick={closeMenu} />
          <NavItem icon="📅" label="Calendar"   to="/group/events"    navigate={navigate} location={location} onClick={closeMenu} />
          <NavItem icon="💰" label="Finances"   to="/group/finances"  navigate={navigate} location={location} onClick={closeMenu} />
          <NavItem icon="✅" label="To-Do List" to="/group/todos"     navigate={navigate} location={location} onClick={closeMenu} />
        </div>
        <div className="sidebar-footer">
          <div className="user-chip">
            <div className="avatar">{name[0].toUpperCase()}</div>
            <div className="user-info" style={{ flex: 1, minWidth: 0 }}>
              <div className="user-name">{name}</div>
              <div className="user-role">Group Leader</div>
            </div>
            <button onClick={logout} title="Logout"
              style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.5)', cursor: 'pointer', fontSize: 16 }}>⏏</button>
          </div>
        </div>
      </div>

      <div className="main-wrap">
        <div className="topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button className="hamburger-btn" onClick={() => setSideOpen(o => !o)} aria-label="Open menu">☰</button>
             <img src="/pcea-logo.png" alt="PCEA" style={{ width:28, height:28, objectFit:'contain' }} className="mobile-hide" />
            <div className="topbar-title">Group Portal</div>
          </div>
          <button className="btn btn-outline btn-sm" onClick={logout}>Logout</button>
        </div>
        <div className="page-content">
          <Routes>
            <Route index           element={<GroupHome />} />
            <Route path="members"  element={<GroupMembers />} />
            <Route path="events"   element={<GroupEvents />} />
            <Route path="finances" element={<GroupFinances />} />
            <Route path="todos"    element={<GroupTodos />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
